import dayjs from 'dayjs';

import * as DateHelper from '../../components/util/DateHelper';
import * as Consts from '../../components/constants/Consts';
import * as ReminderHelper from './ReminderHelper';

export function generateReminder(autorizatie, preference) {
    let reminder = null;

    if( shouldGenerateReminder(autorizatie.autorizatie.dateCertificate, autorizatie.autorizatie.dateMaturity) ) {
        reminder = getAuthorizationReminder(autorizatie.id, autorizatie.autorizatie.dateMaturity, autorizatie.autorizatie.authInternal, preference.offsetCertificateRenewal);
    }

    return reminder;
}


const shouldGenerateReminder = (dateCertificateStr, dateMaturityDateStr) => {
    if( DateHelper.isValidStringDateFmt(dateCertificateStr) && DateHelper.isValidStringDateFmt(dateMaturityDateStr) ) {
        const maturityDate = DateHelper.getDateFromString(dateMaturityDateStr);
        if( maturityDate.isAfter(dayjs()) ) {
            return true;
        }
        else {
            return false;
        }
    }
    else{
        return false;
    }
}


const getAuthorizationReminder = (authorizationId, dataExpirareAutorizatie, authInternal, offsetRenewal) => {
    const reminder = { details:{}};
    reminder.details.type = Consts.REMINDER_RENEW_CERTIFICATE;
    reminder.details.authorizationId = authorizationId;
    reminder.details.authInternal = authInternal;

    reminder.details.dataExpirare = dayjs(dataExpirareAutorizatie);
    reminder.details.dataReminder = ReminderHelper.getReminderDate(dataExpirareAutorizatie, offsetRenewal);

    return reminder;
}


export const getAuthzReminder = (reminder) => {
    const authzReminder = {
        type: reminder.details.type,
        dataReminder: reminder.details.dataReminder,
        dataExpirare: reminder.details.dataExpirare
    };

    return authzReminder;
}

export const getReminderExtra = (employee, employer, worksite) => {
    const extra = {
        employeeId: employee.id,
        eFullName: employee.generalSection.lastName + ' ' + employee.generalSection.firstName,
        clientId: employer.generalSection.rsvtiMBClientId,
        employerId: employee.employmentDetails.employerId,
        employerName: employer.generalSection.employerName,
        worksiteId: employee.employmentDetails.workSiteId,
        worksiteName: worksite.generalSection.name + ', ' + worksite.generalSection.localitate
    };

    return extra;
}